import type { ThemeKey } from 'Src/types/theme';
import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import ratios from 'Components/utils/ratios/ratios.utils';
import Image from 'Components/frameworks/image/Image';
import { ImageSlideShow } from 'Components/frameworks/image-slideshow/ImageSlideShow';
import { themes } from './TeaserCard.themes';

type TeaserCardMedia = {
  alt?: string;
  onClick?: () => void;
  src?: string;
};

type TeaserCardThemeStyles = {
  thRoot: string;
  thImage: string;
  thImageActive?: string;
  thChildren?: string;
  thRootActive?: string;
};

type Props = {
  children?: ReactNode;
  className?: string;
  isActive?: boolean;
  media?: Array<TeaserCardMedia>;
  nextLabel?: string;
  previousLabel?: string;
  ratio?: string;
  theme?: ThemeKey<typeof themes>;
};
export const TeaserCard = ({
  children,
  className,
  isActive,
  media = [],
  nextLabel,
  previousLabel,
  ratio = ratios.R_38_BY_28,
  theme = 'default',
}: Props) => {
  const defaultPicture: TeaserCardMedia = media[0] || {};
  const { thRoot, thRootActive, thChildren, thImage, thImageActive } = themes[
    theme
  ] as TeaserCardThemeStyles;
  return (
    <div
      className={classnames(
        thRoot,
        {
          'h-full': media.length <= 1,
          ...(thRootActive && isActive ? { [thRootActive]: true } : null),
        },
        className,
      )}
    >
      <div className={thChildren}>{children}</div>
      <div
        className={classnames(thImage, {
          ...(thImageActive && isActive ? { [thImageActive]: true } : null),
        })}
      >
        {media.length > 1 ? (
          <ImageSlideShow
            hasLazyLoading
            media={media.filter((item): item is TeaserCardMedia & { src: string } => !!item.src)}
            nextLabel={nextLabel}
            previousLabel={previousLabel}
            ratio={ratio}
          />
        ) : (
          <Image
            altMsg={defaultPicture.alt}
            hasLazyLoading
            imageUrl={defaultPicture.src}
            key={defaultPicture.src}
            ratioKey={ratio}
            ratioDisplay={1 / 4}
          />
        )}
      </div>
    </div>
  );
};
